import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "./client";

export const useUser = (id?: string) => {
  return useQuery({
    queryKey: ["user", id],
    queryFn: async () => {
      const res = await client.user[":id"].$get({
        param: {
          id: id!,
        },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!id,
  });
};
